import axios from './_nestAxios'

export const obtenerTicketsPendientes = () => axios.get('/ope-ose/tickets-pendientes')

export const actualizarEstadoxTicket = ticket =>
  axios.post(
    '/ope-ose/actualizar-estado',
    {},
    {
      params: {
        ticket: ticket
      }
    }
  )
